import { statisticResDto } from '@web/common';
import { authenticatedAPI } from '../AuthenticatedAPI';

export const statisticData = async () => {
  return authenticatedAPI.get(`/api/statistic`, statisticResDto);
};
